import { Component, OnInit } from '@angular/core';
import { HeaderDetails } from '../header/header.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  headerDetails : HeaderDetails;

  constructor() { }

  ngOnInit() {
        this.headerDetails = { 'title' : 'Hello world',
                                'description' : '',
                                 'img' : '' };
  }
}
